module.exports = __webpack_public_path__ + "img/404page.161e0ff1.svg";